export const en = {
    titreOnglet: "Account Detail | Desjardins"
};
